import {DELETE_GROUP_POSTS_START} from "../../types";

export const delete_group_posts = (payload) => ({
    type: DELETE_GROUP_POSTS_START,
    payload,
});
